import { VendorTableCellPillDisplay } from "../vendor-documentation/vendorTableCellDisplay";
import {
  doesVendorHaveSellingComplete,
  doesVendorHaveSharingComplete,
  isDataSellingLockedForVendor,
  shouldShowDataSellingSection,
  shouldShowSharing,
} from "./vendorInventoryUtils";
import { VendorInventoryItem } from "./vendorInventoryUtils";
import { SurveyAnswers } from "../../../../common/hooks/api/useSurvey";
import { CollectionContext } from "../../../../common/service/server/dto/OrganizationDataRecipientDto";

export const getTargetedAdsCell = (
  vendor: VendorInventoryItem,
  pageContext: CollectionContext,
): VendorTableCellPillDisplay => {
  if (
    !vendor.isRecipient ||
    !vendor.recipientData ||
    vendor.isInternalDataStorageLocation ||
    !shouldShowSharing(vendor.recipientData, pageContext)
  ) {
    return {
      text: "-",
    };
  }

  if (!doesVendorHaveSharingComplete(vendor.recipientData)) {
    return {
      color: "yellow",
      text: "Incomplete",
    };
  }

  if (vendor.recipientData.ccpaIsSharing === true) {
    return {
      text: "GREEN_CHECKMARK_ICON",
    };
  } else if (vendor.recipientData.ccpaIsSharing === false) {
    return {
      text: "GRAY_X_ICON",
    };
  } else {
    return {
      color: "yellow",
      text: "Incomplete",
    };
  }
};

export const getDataSourceCell = (
  vendor: VendorInventoryItem,
): VendorTableCellPillDisplay | VendorTableCellPillDisplay[] => {
  let result: VendorTableCellPillDisplay[] = [];

  if (vendor.isRecipient) {
    result.push({
      text: "Recipient",
      color: "blue",
    });
  }

  if (vendor.isSource) {
    result.push({
      text: "Source",
      color: "green",
    });
  }

  return result;
};

export const getDataSellingCell = (
  vendor: VendorInventoryItem,
  sellingAndSharingAnswers: SurveyAnswers,
  pageContext: CollectionContext,
): VendorTableCellPillDisplay => {
  if (
    !vendor.isRecipient ||
    !vendor.recipientData ||
    vendor.isInternalDataStorageLocation ||
    !shouldShowDataSellingSection(vendor.recipientData, pageContext)
  ) {
    return {
      text: "-",
    };
  }

  if (!doesVendorHaveSellingComplete(vendor.recipientData, sellingAndSharingAnswers)) {
    return {
      color: "yellow",
      text: "Incomplete",
    };
  }

  const lockedSellingValues = isDataSellingLockedForVendor(
    vendor.recipientData,
    sellingAndSharingAnswers,
  );

  if (
    vendor.recipientData.ccpaIsSelling === true ||
    vendor.recipientData.isAlwaysDataSellingVendor ||
    lockedSellingValues.dataSelling === true
  ) {
    return {
      text: "GREEN_CHECKMARK_ICON",
    };
  } else {
    return {
      text: "GRAY_X_ICON",
    };
  }
};
